import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import { getCurrentUser } from "vuefire";
import PaymentsSummaryVue from "../pages/PaymentsSummary.vue";
import StorePaymentsSummaryVue from "../pages/StorePaymentsSummary.vue";
import StorePayoutsSummaryVue from "../pages/StorePayoutsSummary.vue";
import StorePaymentsPageVue from "../pages/StorePaymentsPage.vue";
import StoreInitiedRefundsPageVue from "../pages/StoreInitiedRefundsPage.vue";
function lazyView(view: string) {
  return () => import(`../pages/${view}.vue`);
}
const StorePage = () => import("../pages/StorePage.vue");
const StoreDetailPage = () => import("../pages/StoreDetailPage.vue");
const StoreSettingsPage = () => import("../pages/StoreSettingsPage.vue");
const StorePasswordsPage = () => import("../pages/PasswordsPage.vue");
const LargePaymentsPage = () => import("../pages/LargePaymentsPage.vue");
const StoreRefundsPageVue = () => import("../pages/StoreRefundsPage.vue");
const StoreChargebacksPageVue = () =>
  import("../pages/StoreChargebacksPage.vue");
const StoreSettingsCommissionPage = () =>
  import("../pages/StoreSettingsCommissionPage.vue");
const StoreSettingsEcomCommissionPage = () =>
  import("../pages/StoreSettingsEcomCommissionPage.vue");
const StoreSettingsSweepPage = () =>
  import("../pages/StoreSettingsSweepPage.vue");
const StoreSettingsMonthlyRentalFeePage = () =>
  import("../pages/StoreSettingsMonthlyRentalFeePage.vue");
const DashboardPage = () => import("../pages/DashboardPage.vue");
const StoreSettingsSplitConfigurationPage = () =>
  import("../pages/StoreSettingsSplitConfigurationPage.vue");

const StoreSettingsTerminalPage = () =>
  import("../pages/StoreSettingsTerminalPage.vue");
const StoreSettingsReceiptPage = () =>
  import("../pages/StoreSettingsReceiptPage.vue");
const StoreSettingsLogo = () => import("../pages/StoreSettingLogo.vue");
const StoreSettingsPasscodes = () =>
  import("../pages/StoreSettingsPasscodesPage.vue");
const StoreSettingsEnableStandalone = () =>
  import("../pages/StoreSettingsEnableStandalone.vue");
const StoreSettingsEnableWechatpayPos = () =>
  import("../pages/StoreSettingsEnableWechatpayPos.vue");
const StoreSettingsEnableAlipayPos = () =>
  import("../pages/StoreSettingsEnableAlipayPos.vue");
const StoreSettingsEnableAmex = () =>
  import("../pages/StoreSettingsEnableAmex.vue");
const StoreSettingsEnableUnionpay = () =>
  import("../pages/StoreSettingsEnableUnionpay.vue");
const StoreSettingsPartialRefund = () =>
  import("../pages/StoreSettingsPartialRefund.vue");
const StoreSettingsRemotePaymentPage = () =>
  import("../pages/StoreSettingsRemotePaymentPage.vue");
const StoreSettingsFranchisePage = () =>
  import("../pages/StoreSettingsFranchisePage.vue");
const StoreSettingsChannelPage = () =>
  import("../pages/StoreSettingsChannelPage.vue");
const StoreSettingsEnableSamedaySettlement = () =>
  import("../pages/StoreSettingsEnableSamedaySettlement.vue");
const StoreSettingsSurchargePage = () =>
  import("../pages/StoreSettingsSurchargePage.vue");
const StoreSettingsTips = () => import("../pages/StoreSettingsTips.vue");
const StoreSettingsBonusPage = () =>
  import("../pages/StoreSettingsBonusPage.vue");
const StoreSettingsABNPage = () => import("../pages/StoreSettingsABNPage.vue");
const StoreSettingsAppsPage = () =>
  import("../pages/StoreSettingsAppsPage.vue");
const StoreSettingsPasswordsPage = () =>
  import("../pages/StoreSettingsPasswordsPage.vue");
const StoreSettingsStoreAccessPage = () =>
  import("../pages/StoreSettingsStoreAccessPage.vue");
const ReceiptPage = () => import("../pages/ReceiptPage.vue");
const routes: Array<RouteRecordRaw> = [
  {
    path: "/receipts/:id",
    name: "ReceiptPage",
    component: ReceiptPage,
  },
  {
    path: "/",
    name: "Intro",
    component: DashboardPage,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "home-redirect",
        redirect: (_to) => ({ name: "HomePage" }),
      },
      {
        path: "dashboard",
        name: "HomePage",
        component: lazyView("HomePage"),
      },
      {
        path: "help",
        name: "HelPage",
        component: lazyView("HelpPage"),
      },
      {
        path: "get-connected",
        name: "OnboardingPage",
        component: lazyView("OnboardingPage"),
      },
      {
        path: "/payments",
        name: "PaymentsPage",
        component: lazyView("PaymentsPage"),
      },
      {
        path: "/large-payments",
        name: "LargePaymentsPage",
        component: LargePaymentsPage,
      },
      {
        path: "/refunds",
        name: "RefundsPage",
        component: lazyView("RefundsPage"),
      },
      {
        path: "/users",
        name: "AddUserPage",
        component: lazyView("AddUserPage"),
      },
      {
        path: "/settlements",
        name: "SettlementsPage",
        component: lazyView("SettlementReportPage"),
      },
      {
        path: "/settlement-report",
        name: "SettlementReportPage",
        component: lazyView("SettlementReportPage"),
      },
      {
        path: "/deductions",
        name: "DeductionsPage",
        component: lazyView("DeductionsPage"),
      },
      {
        path: "/monthly-rental-fees",
        name: "MonthlyRentalFeesPage",
        component: lazyView("MonthlyRentalFeesPage"),
      },
      {
        path: "/orders",
        name: "AdminOrdersPage",
        component: lazyView("AdminOrdersPage"),
      },
      {
        path: "/products",
        name: "ProductsPage",
        component: lazyView("ProductsPage"),
      },
      {
        path: "/stores",
        name: "StoresPage",
        component: lazyView("StoresPage"),
      },
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: lazyView("PermissionsPage"),
      },
      {
        path: "/activity-log",
        name: "ActivityLogPage",
        component: lazyView("ActivityLogPage"),
      },
      {
        path: "/channels",
        name: "ChannelsPage",
        component: lazyView("ChannelsPage"),
      },
      {
        path: "/franchise",
        name: "FranchisePage",
        component: lazyView("FranchisePage"),
      },
      {
        path: "/profit-analytics",
        name: "ProfitAnalyticsPage",
        component: lazyView("ProfitAnalyticsPage"),
      },
      {
        path: "/stores/:store/settings",
        name: "UserStoreSettingsPage",
        component: lazyView("SettingsPage"),
      },
      {
        path: "/merchants/:merchant/payouts",
        name: "PayoutsPage",
        component: lazyView("MerchantPayoutPage"),
      },

      {
        path: "/merchants/:merchant/new-order",
        name: "NewOrder",
        component: lazyView("NewOrderPage"),
      },
      {
        path: "/merchants/:merchant/orders",
        name: "OrderPage",
        component: lazyView("OrderPage"),
      },
      {
        path: "/merchants/:merchant/stores/:store",
        name: "StorePage",
        component: StorePage,
        children: [
          {
            path: "",
            name: "store-redirect",
            redirect: (_to) => ({ name: "StoreDetailPage" }),
          },
          {
            path: "admin-payments",
            name: "admin-payments-summary",
            component: PaymentsSummaryVue,
          },
          {
            path: "payments",
            name: "payments-summary",
            component: StorePaymentsSummaryVue,
          },
          {
            path: "payouts",
            name: "payouts-summary",
            component: StorePayoutsSummaryVue,
          },
          {
            path: "payments/:date",
            name: "store-payments",
            component: StorePaymentsPageVue,
          },
          {
            path: "initiated-refunds/:date",
            name: "store-initiated-refunds",
            component: StoreInitiedRefundsPageVue,
          },
          {
            path: "refunds/:date",
            name: "store-refunds",
            component: StoreRefundsPageVue,
          },
          {
            path: "chargebacks/:date",
            name: "store-chargebacks",
            component: StoreChargebacksPageVue,
          },
          {
            path: "admin-payments/:date",
            name: "StoreDetailPage",
            component: StoreDetailPage,
          },
          {
            path: "dashboard",
            name: "StorePayoutsPage",
            // Render the payments-summary template on the dashboard route.
            component: StorePaymentsSummaryVue,
          },
          {
            path: "passwords",
            name: "StorePasswordsPage",
            component: StorePasswordsPage,
          },
          {
            path: "settings",
            name: "StoreSettingsPage",
            component: StoreSettingsPage,
            children: [
              {
                path: "",
                name: "settings-redirect",
                redirect: (_to) => ({ name: "StoreSettingsTerminalPage" }),
              },
              {
                path: "commission",
                name: "StoreSettingsCommissionPage",
                component: StoreSettingsCommissionPage,
              },
              {
                path: "ecom-commission",
                name: "StoreSettingsEcomCommissionPage",
                component: StoreSettingsEcomCommissionPage,
              },
              {
                path: "bonus",
                name: "StoreSettingsBonusPage",
                component: StoreSettingsBonusPage,
              },
              {
                path: "abn",
                name: "StoreSettingsABNPage",
                component: StoreSettingsABNPage,
              },
              {
                path: "apps",
                name: "StoreSettingsAppsPage",
                component: StoreSettingsAppsPage,
              },
              {
                path: "app-passwords",
                name: "StoreSettingsPasswordsPage",
                component: StoreSettingsPasswordsPage,
              },
              {
                path: "store-access",
                name: "StoreSettingsStoreAccessPage",
                component: StoreSettingsStoreAccessPage,
              },
              {
                path: "sweep",
                name: "StoreSettingsSweepPage",
                component: StoreSettingsSweepPage,
              },
              {
                path: "monthly-rental-fee",
                name: "StoreSettingsMonthlyRentalFeePage",
                component: StoreSettingsMonthlyRentalFeePage,
                props: true,
              },
              {
                path: "terminal",
                name: "StoreSettingsTerminalPage",
                component: StoreSettingsTerminalPage,
                props: true,
              },
              {
                path: "receipt",
                name: "StoreSettingsReceiptPage",
                component: StoreSettingsReceiptPage,
                props: true,
              },
              {
                path: "surcharge",
                name: "StoreSettingsSurchargePage",
                component: StoreSettingsSurchargePage,
                props: true,
              },
              {
                path: "tips",
                name: "StoreSettingsTips",
                component: StoreSettingsTips,
                props: true,
              },
              {
                path: "split-configuration",
                name: "StoreSettingsSplitConfigurationPage",
                component: StoreSettingsSplitConfigurationPage,
              },
              {
                path: "logo",
                name: "StoreSettingsLogo",
                component: StoreSettingsLogo,
              },
              {
                path: "passcodes",
                name: "StoreSettingsPasscodes",
                component: StoreSettingsPasscodes,
              },
              {
                path: "standalone",
                name: "StoreSettingsEnableStandalone",
                component: StoreSettingsEnableStandalone,
              },
              {
                path: "wechatpaypos",
                name: "StoreSettingsEnableWechatpayPos",
                component: StoreSettingsEnableWechatpayPos,
              },
              {
                path: "alipaypaypos",
                name: "StoreSettingsEnableAlipayPos",
                component: StoreSettingsEnableAlipayPos,
              },
              {
                path: "amex",
                name: "StoreSettingsEnableAmex",
                component: StoreSettingsEnableAmex,
                props: true,
              },
              {
                path: "unionpay",
                name: "StoreSettingsEnableUnionpay",
                component: StoreSettingsEnableUnionpay,
                props: true,
              },
              {
                path: "partial-refund",
                name: "StoreSettingsPartialRefund",
                component: StoreSettingsPartialRefund,
                props: true,
              },
              {
                path: "remote-payment",
                name: "StoreSettingsRemotePaymentPage",
                component: StoreSettingsRemotePaymentPage,
                props: true,
              },
              {
                path: "franchise",
                name: "StoreSettingsFranchisePage",
                component: StoreSettingsFranchisePage,
                props: true,
              },
              {
                path: "channel",
                name: "StoreSettingsChannelPage",
                component: StoreSettingsChannelPage,
                props: true,
              },
              {
                path: "sameday-settlement",
                name: "StoreSettingsEnableSamedaySettlement",
                component: StoreSettingsEnableSamedaySettlement,
              },
            ],
          },
        ],
      },

      {
        path: "/new-store",
        name: "NewVenuePage",
        component: lazyView("NewVenuePage"),
      },
      {
        path: "/onboarding",
        name: "Onboarding",
        component: lazyView("Onboarding"),
      },
      {
        path: "/add-store",
        name: "NewStorePage",
        component: lazyView("NewStorePage"),
      },
      {
        path: "/manual-transfer",
        name: "ManualTransferPage",
        component: lazyView("ManualTransferPage"),
      },
    ],
  },
  {
    // Self-serve KYC / API-driven onboarding. Intentionally not linked from any
    // nav yet — reachable by URL only for testing.
    path: "/kyc",
    name: "KycPage",
    component: lazyView("KycPage"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "LoginPage",
    component: lazyView("LoginWithEmailPage"),
  },
  {
    path: "/checkout",
    name: "CheckoutPage",
    component: lazyView("CheckoutPage"),
  },
  {
    path: "/payment-result",
    name: "PaymentResultPage",
    component: lazyView("PaymentResultPage"),
  },
  {
    path: "/login-with-email",
    name: "LoginWithEmailPage",
    component: lazyView("LoginWithEmailPage"),
  },
  {
    path: "/email-signin",
    name: "EmailSignPage",
    component: lazyView("EmailSigninPage"),
  },
  {
    path: "/7499",
    name: "BalancesPage",
    component: lazyView("BalancesPage"),
  },
  {
    path: "/cass",
    name: "CassPage",
    component: lazyView("CassPage"),
  },
  {
    path: "/rex",
    name: "RexPage",
    component: lazyView("RexPage"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  // routes with `meta: { requiresAuth: true }` will check for
  // the users, others won't
  if (to.meta.requiresAuth) {
    const currentUser = await getCurrentUser();
    // if the user is not logged in, redirect to the login page
    if (!currentUser) {
      return {
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      };
    }
  }
});

export default router;
